import React, { useState } from "react";
import styles from "../../../styles/about/components/AboutLeadership.module.css";
import apostleImg from "../../../assets/images/father.png";
import serugoImg from "../../../assets/images/RevEspoir.png";
import ngogaImg from "../../../assets/images/ngoga.png";
import richardImg from "../../../assets/images/richard.png";
import martinImg from "../../../assets/images/Martin.png";
import { 
  FaFacebookF, 
  FaYoutube, 
  FaInstagram, 
  FaLinkedinIn,
  FaChevronRight,
  FaTimes,
  FaExternalLinkAlt 
} from "react-icons/fa";

const globalLeadership = [
  {
    id: 1,
    name: "Apostle Christophe Sebagabo",
    title: "Representative",
    subtitle: "Visionary and Founder",
    img: apostleImg,
    socials: {
      facebook: "#",
      youtube: "#",
      instagram: "#",
    }
  },
  {
    id: 2,
    name: "Rev Espoir Serugo",
    title: "Legal Representative",
    subtitle: "Legal Representative",
    img: serugoImg,
    socials: {
      facebook: "#",
      youtube: "#",
      instagram: "#",
    }
  }
];

const localLeadership = [
  {
    id: 3,
    name: "Apostle Christophe Sebagabo",
    title: "Senior Pastor",
    subtitle: "Kigali Main Parish",
    img: apostleImg,
    socials: {
      facebook: "#",
      youtube: "#",
      instagram: "#",
    }
  },
  {
    id: 4,
    name: "Rev Espoir Serugo",
    title: "Pastor",
    subtitle: "Kigali Main Parish",
    img: serugoImg,
    socials: {
      facebook: "#",
      youtube: "#",
      instagram: "#",
    }
  },
  {
    id: 5,
    name: "Pastor Ngoga Christophe",
    title: "Executive Pastor",
    subtitle: "Kigali Main Parish",
    img: ngogaImg,
    socials: {
      facebook: "#",
      youtube: "#",
      instagram: "#",
    }
  },
  {
    id: 6,
    name: "Pastor Richard Sebagabo",
    title: "Pastor - Social & Development Division",
    subtitle: "Kigali Main Parish",
    img: richardImg,
    socials: {
      facebook: "#",
      youtube: "#",
      instagram: "#",
    }
  },
  {
    id: 7,
    name: "Pastor Martin Rutekereza",
    title: "Pastor - Discipleship Division",
    subtitle: "Kigali Main Parish",
    img: martinImg,
    socials: {
      facebook: "#",
      youtube: "#",
      instagram: "#",
    }
  },
];

export default function AboutLeadership() {
  return (
    <>
      <section className={styles.section} id="leadership">
        <div className={styles.container}>
          <div className={styles.header}>
            <h2 className={styles.title}>MEET THE TEAM</h2>
            <div className={styles.decorativeLine} />
          </div>
          
          {/* Global Leadership */}
          <div className={styles.levelSection}>
            <h3 className={styles.levelTitle}>Global Leadership</h3>
            <div className={styles.gridGlobal}>
              {globalLeadership.map((leader) => (
                <article 
                  className={styles.card} 
                  key={leader.id}
                >
                  <div className={styles.cardInner}>
                    <div className={styles.imgWrap}>
                      <img 
                        src={leader.img} 
                        alt={`Portrait of ${leader.name}`} 
                        className={styles.img} 
                        loading="lazy"
                      />
                    </div>
                    
                    <div className={styles.info}>
                      <h3 className={styles.name}>{leader.name}</h3>
                      <p className={styles.role}>{leader.title}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* Local Leadership */}
          <div className={styles.levelSection}>
            <h3 className={styles.levelTitle}>Local Leadership - Kigali Main Parish</h3>
            <div className={styles.gridLocal}>
              {localLeadership.map((leader) => (
                <article 
                  className={styles.card} 
                  key={leader.id}
                >
                  <div className={styles.cardInner}>
                    <div className={styles.imgWrap}>
                      <img 
                        src={leader.img} 
                        alt={`Portrait of ${leader.name}`} 
                        className={styles.img} 
                        loading="lazy"
                      />
                    </div>
                    
                    <div className={styles.info}>
                      <h3 className={styles.name}>{leader.name}</h3>
                      <p className={styles.role}>{leader.title}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}